import { render, staticRenderFns } from "./CallGroups.vue?vue&type=template&id=5657b4eb"
import script from "./CallGroups.vue?vue&type=script&lang=js"
export * from "./CallGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports